import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2, AlertTriangle } from "lucide-react";
import api from "../../lib/api";
import SEO from "../../components/SEO";

export default function AdminVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, error: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, error: "Token saknas i länken." });
      return;
    }
    // Server sets the HttpOnly `tf_session` cookie on success. The JSON body
    // still carries the same JWT for legacy Bearer flows / tests, but the
    // browser doesn't need it — the cookie carries the whole session.
    api
      .post("/auth/verify", { token })
      .then(() => setState({ loading: false, ok: true, error: "" }))
      .catch((err) => {
        setState({
          loading: false,
          ok: false,
          error: err?.response?.data?.detail || "Ogiltig eller utgången länk",
        });
      });
  }, [token]);

  if (state.ok) return <Navigate to="/admin/forfragningar" replace />;

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-[#F7F5F0]">
      <SEO
        title="Verifierar inloggning…"
        description="Verifierar admin-länk."
        path="/admin/verifiera"
        noindex
      />
      <div className="w-full max-w-md bg-white border border-[#E2E0D8] rounded-xl p-8 text-center">
        {state.loading ? (
          <>
            <Loader2 className="w-8 h-8 animate-spin text-[#D95D2E] mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-bold text-[#1B2A1E]">
              Loggar in…
            </h1>
            <p className="text-[#5A6258] mt-2">Det går snabbt.</p>
          </>
        ) : (
          <>
            <AlertTriangle className="w-8 h-8 text-[#D95D2E] mx-auto mb-4" />
            <h1 className="font-heading text-2xl font-bold text-[#1B2A1E]">
              Inloggning misslyckades
            </h1>
            <p className="text-[#5A6258] mt-2">{state.error}</p>
            <a
              href="/admin"
              data-testid="admin-verify-retry"
              className="mt-6 inline-flex items-center justify-center bg-[#D95D2E] hover:bg-[#B84B22] text-white font-semibold px-5 py-3 rounded-lg transition-colors"
            >
              Försök igen
            </a>
          </>
        )}
      </div>
    </div>
  );
}
